import SoilSupplierPropertiesComponent, { ISelectedProps } from './SoilSupplierPropertiesComponent';

export default SoilSupplierPropertiesComponent;
export type {
    ISelectedProps
};